import { EConsommableAir } from "src/app/domain/Air/enum/consommable-air";
import { ELieuPrelevementAir } from "src/app/domain/Air/enum/lieu-prelevement";
import { EMethodePrelevement } from "src/app/domain/Air/enum/methode-prelevement";
import { EMilieuPrelevementAir } from "src/app/domain/Air/enum/milieu-prelevement";
import { EConsommableDialyse } from "src/app/domain/Dialyse/enum/consommable-dialyse";
import { ELocalisationDialyse } from "src/app/domain/Dialyse/enum/localisation-dialyse";
import { EModeDesinfection } from "src/app/domain/Dialyse/enum/mode-desinfection";
import { EConditionPrelevement as CPE } from "src/app/domain/Endoscope/enums/condition-prelevement";
import { EConditionStockage } from "src/app/domain/Endoscope/enums/condition-stockage";
import { EConsommableEndoscope } from "src/app/domain/Endoscope/enums/consommable-endoscope";
import { EMarque } from "src/app/domain/Endoscope/enums/marque";
import { EMotifPrelevement } from "src/app/domain/Endoscope/enums/motif-prelevement";
import { EPortee } from "src/app/domain/Endoscope/enums/portee";
import { ETraitement } from "src/app/domain/Endoscope/enums/traitement";
import { EType } from "src/app/domain/Endoscope/enums/type";
import { ETypeEauRincage } from "src/app/domain/Endoscope/enums/type-eau-rincage";
import { EClasse } from "src/app/domain/Qualif/enums/classe";
import { EClasseBPP } from "src/app/domain/Qualif/enums/classe-bpp";
import { EClasseBPPH } from "src/app/domain/Qualif/enums/classe-bpph";
import { EClasseComptageParticulaire } from "src/app/domain/Qualif/enums/classe-comptage-particulaire";
import { ELocalisationQualifSalle } from "src/app/domain/Qualif/enums/localisation-salle";
import { EMarqueAppareilAir } from "src/app/domain/Qualif/enums/marque-appareil-air";
import { EMarqueAppareilSurface } from "src/app/domain/Qualif/enums/marque-appareil-surface";

import { EMarqueCompteur } from "src/app/domain/Qualif/enums/marque-compteur";
import { EMarqueMultimetre } from "src/app/domain/Qualif/enums/marque-multimetre";
import { EModeleAppareilAir } from "src/app/domain/Qualif/enums/modele-appareil-air";
import { EModeleAppareilSurface } from "src/app/domain/Qualif/enums/modele-appareil-surface";

import { EModeleCompteur } from "src/app/domain/Qualif/enums/modele-compteur";
import { EModeleMultimetre } from "src/app/domain/Qualif/enums/modele-multimetre";
import { ESystemeTraitementAir } from "src/app/domain/Qualif/enums/systeme-traitement-air";
import { ETestFumee } from "src/app/domain/Qualif/enums/test-fumee";
import { ETypeAppareil } from "src/app/domain/Qualif/enums/type-appareil";
import { EConsommableSurface } from "src/app/domain/Surface/enum/consommable-surface";
import { ELieuPrelevementSurface } from "src/app/domain/Surface/enum/lieu-prelevement";
import { EMilieuPrelevementSurface } from "src/app/domain/Surface/enum/milieu-prelevement";
import { EConditionPrelevement as CP } from "src/app/domain/enums/condition-prelevement";
import { EFlaskType } from "src/app/domain/enums/flask-type";
import { EScopeType } from "src/app/domain/user-profile/scope-type";

export class StringConverter {
    static getTestFumeeLabel(type: ETestFumee) {
        switch (type) {
            case ETestFumee.AbsenceConfinementSalle:
                return 'Absence confinement salle';
            case ETestFumee.ConfinementSalle:
                return 'Confinement salle';
            case ETestFumee.TestNonRealise:
                return 'Test non réalisé';
            default:
                return 'Not Set';
        }
    }

    static getTypeAppareilLabel(type: ETypeAppareil) {
        switch (type) {
            case ETypeAppareil.ApplicateurContact:
                return 'Applicateur Contact';
            case ETypeAppareil.Biocollecteur:
                return 'Biocollecteur 1';
            case ETypeAppareil.Biocollecteur2:
                return 'Biocollecteur 2';
            case ETypeAppareil.Compteur:
                return 'Compteur';
            case ETypeAppareil.Multimetre:
                return 'Multimètre';
            // case ETypeAppareil.Luxmetre:
            //     return 'Luxmètre';
            // case ETypeAppareil.Sonometre:
            //     return 'Sonomètre';
            default:
                return 'Not Set';
        }
    }

    static getLocalisationQualifSalleLabel(type: ELocalisationQualifSalle) {
        switch (type) {
            case ELocalisationQualifSalle.Autre:
                return 'Autre';
            case ELocalisationQualifSalle.BlocOperatoire:
                return 'Bloc opératoire';
            case ELocalisationQualifSalle.Pharmacie:
                return 'Pharmacie';
            case ELocalisationQualifSalle.Sterilisation:
                return 'Stérilisation';
            case ELocalisationQualifSalle.UniteDeSoinsIntensifs:
                return 'Unité de soins intensifs';
            case ELocalisationQualifSalle.UniteDePreparationDeMedicament:
                return 'Unite de préparation de médicament';
            default:
                return 'Not Set';
        }
    }

    static getClasseLabel(type: EClasse) {
        switch (type) {
            case EClasse.Risque2:
                return 'Risque 2';
            case EClasse.Risque3:
                return 'Risque 3';
            case EClasse.Risque4:
                return 'Risque 4';
            case EClasse.Risque2_2003:
                return 'Risque 2 - 2003';
            case EClasse.Risque3_2003:
                return 'Risque 3 - 2003';
            case EClasse.Risque4_2003:
                return 'Risque 4 - 2003';
            // case EClasse.BPPClasseA:
            //     return 'BPP Classe A';
            // case EClasse.BPPClasseB:
            //     return 'BPP Classe B';
            // case EClasse.BPPClasseC:
            //     return 'BPP Classe C';
            // case EClasse.BPPClasseD:
            //     return 'BPP Classe D';
            // case EClasse.BPPH:
            //     return 'BPPH';
            // case EClasse.ComptageParticulaire:
            //     return 'Comptage Particulaire';
            default:
                return 'Not Set';
        }
    }

    static getClasseBPPLabel(type: EClasseBPP): any {
        switch (type) {
            case EClasseBPP.ClasseA:
                return 'Classe A';
            case EClasseBPP.ClasseB:
                return 'Classe B';
            case EClasseBPP.ClasseC:
                return 'Classe C';
            case EClasseBPP.ClasseD:
                return 'Classe D';
            default:
                return 'Not Set';
        }
    }

    static getClasseBPPHLabel(type: EClasseBPPH): any {
        switch (type) {
            case EClasseBPPH.BPPH:
                return 'BPP H';
            default:
                return 'Not Set';
        }
    }

    static getClasseComptageParticulaireLabel(type: EClasseComptageParticulaire): any {
        switch (type) {
            case EClasseComptageParticulaire.CP_ISO5:
                return 'ISO 5';
            case EClasseComptageParticulaire.CP_ISO7:
                return 'ISO 7';
            case EClasseComptageParticulaire.CP_ISO8:
                return 'ISO 8';
            case EClasseComptageParticulaire.CP_ClasseA:
                return 'Classe A';
            case EClasseComptageParticulaire.CP_ClasseB:
                return 'Classe B';
            case EClasseComptageParticulaire.CP_ClasseC:
                return 'Classe C';
            case EClasseComptageParticulaire.CP_ClasseD:
                return 'Classe D';
            default:
                return 'Not Set';
        }
    }

    static getModeDesinfectionLabel(type: EModeDesinfection): any {
        switch (type) {
            case EModeDesinfection.Aucune:
                return 'Aucune';
            case EModeDesinfection.Alcool:
                return 'Alcool';
            case EModeDesinfection.Flambage:
                return 'Flambage';
            case EModeDesinfection.Lingette:
                return 'Lingettes désinfectantes';
            default:
                return 'Not Set';
        }
    }

    static getConfirmMessageByLabel(label: string) {
        switch (label) {
            case 'confirm-removal-generic':
                return 'Etes-vous sûr de vouloir supprimer cet élément ?';
            case 'confirm-removal-strategy':
                return 'Etes-vous sûr de vouloir supprimer cette stratégie ?';
            default:
                return 'Not Set';
        }
    }

    static getScopeTypeName(type: EScopeType) {
        switch (type) {
            case EScopeType.All:
                return 'All';
            case EScopeType.BusinessUnitCluster:
                return 'Business Unit Cluster';
            case EScopeType.LabSite:
                return 'Lab Site';
            case EScopeType.NationalBusinessLine:
                return 'National Business Line';
            default:
                return 'Not Set';
        }
    }

    static getConditionPrelevement(type: CP) {
        switch (type) {
            case CP.EnActivite:
                return 'En Activité';
            case CP.HorsActivite:
                return 'Hors Activité';
            default:
                return 'Not Set';
        }
    }

    static getMilieuPrelevement(type: EMilieuPrelevementAir) {
        switch (type) {
            case EMilieuPrelevementAir.PCA:
                return 'PCA';
            case EMilieuPrelevementAir.PCA_SAB:
                return 'PCA SAB';
            case EMilieuPrelevementAir.SAB:
                return 'SAB';
            default:
                return 'Not Set';
        }
    }

    static getMilieuPrelevementSurface(type: EMilieuPrelevementSurface) {
        switch (type) {
            case EMilieuPrelevementSurface.Ecouvillons:
                return 'Ecouvillons';
            case EMilieuPrelevementSurface.BoiteContact:
                return 'BoiteContact';
            case EMilieuPrelevementSurface.Lames:
                return 'Lames';
            case EMilieuPrelevementSurface.Lingettes:
                return 'Lingettes';
            default:
                return 'Not Set';
        }
    }

    static getLieuPrelevementAir(type: ELieuPrelevementAir) {
        switch (type) {
            // case ELieuPrelevementAir.MilieuSalle:
            //     return 'Milieu Salle';
            case ELieuPrelevementAir.Autre:
                return 'Autres';
            default:
                return 'Not Set';
        }
    }

    static getLieuPrelevementSurface(type: ELieuPrelevementSurface) {
        switch (type) {
            case ELieuPrelevementSurface.BistouriElectrique:
                return 'Bistouri Electrique';
            case ELieuPrelevementSurface.ChariotAnesthesie:
                return 'Chariot Anesthesie';
            case ELieuPrelevementSurface.ChariotInox:
                return 'Chariot Inox';
            case ELieuPrelevementSurface.Respirateur:
                return 'Respirateur';
            case ELieuPrelevementSurface.Scialytique:
                return 'Scialytique';
            case ELieuPrelevementSurface.TableInstruments:
                return 'Table Instruments';
            case ELieuPrelevementSurface.TableOperation:
                return 'Table Operation';
            case ELieuPrelevementSurface.Autre:
                return 'Autres';
            case ELieuPrelevementSurface.ParoiGauche:
                return 'Paroi Gauche';
            case ELieuPrelevementSurface.ParoiDroite:
                return 'Paroi Droite';
            case ELieuPrelevementSurface.Sol:
                return 'Sol';
            case ELieuPrelevementSurface.SupportEndoscope:
                return 'Support Endoscope';
            default:
                return 'Not Set';
        }
    }

    static getLocalisationDialyseLabel(type: ELocalisationDialyse) {
        switch (type) {
            case ELocalisationDialyse.Dialysat:
                return 'Dialysat';
            case ELocalisationDialyse.LiquideSubstitution:
                return 'Liquide Substitution';
            case ELocalisationDialyse.LiquideRestitution:
                return 'Liquide Restitution';
            case ELocalisationDialyse.Autre:
                return 'Autre';
            default:
                return 'Not Set';
        }
    }

    static getMethodePrelevement(type: EMethodePrelevement) {
        switch (type) {
            case EMethodePrelevement.Impaction:
                return 'Impaction';
            case EMethodePrelevement.Sedimentation:
                return 'Sédimentation';
            default:
                return 'Not Set';
        }
    }

    static getFlaskTypeLabel(type: EFlaskType) {
        switch (type) {
            case EFlaskType.H1:
                return 'H1';
            case EFlaskType.H2:
                return 'H2';
            case EFlaskType.H3:
                return 'H3';
            case EFlaskType.H4:
                return 'H4';
            case EFlaskType.S1:
                return 'S1';
            case EFlaskType.H6:
                return 'H6';
            case EFlaskType.LS26N:
                return 'LS26N';
            case EFlaskType.P17:
                return 'P17'
            case EFlaskType.P02:
                return 'P02'
            default:
                return 'Not Set';
        }
    }

    static getConsommableDialyseLabel(type: EConsommableDialyse) {
        switch (type) {
            case EConsommableDialyse.H16:
                return 'H16 : Gambro 500mL';
            case EConsommableDialyse.H162:
                return 'H16/2 : Fresenius 5008 1L';
            case EConsommableDialyse.H172:
                return 'H17/2 : Hemotech 1L (Hansen)';
            case EConsommableDialyse.H355:
                return 'H355 : Hemotech en T 1L (Luer Lock)';
            case EConsommableDialyse.H356:
                return 'H356 : Adaptateur Nikkiso';
            case EConsommableDialyse.TubeEndotoxine:
                return 'TubeEndotoxine';
            default:
                return 'Not Set';
        }
    }

    static getConsommableEndoscopeLabel(type: EConsommableEndoscope) {
        switch (type) {
            // case EConsommableDialyse.H16:
            //     return 'H16 : Gambro 500mL';
            // case EConsommableDialyse.H162:
            //     return 'H16/2 : Fresenius 5008 1L';
            // case EConsommableDialyse.H172:
            //     return 'H17/2 : Hemotech 1L';
            // case EConsommableDialyse.H355:
            //     return 'H355 : Hemotech en T 1L';
            // case EConsommableDialyse.H356:
            //     return 'H356 : Adaptateur Nikkiso';
            // case EConsommableDialyse.TubeEndotoxine:
            //     return 'TubeEndotoxine';
            default:
                return 'Not Set';
        }
    }
    static getConsommableAirLabel(type: EConsommableAir) {
        switch (type) {
            case EConsommableAir.GelosePCA:
                return 'Gelose PCA';
            case EConsommableAir.GeloseSabouraud:
                return 'Gelose Sabouraud';
            default:
                return 'Not Set';
        }
    }

    static getConsommableSurfaceLabel(type: EConsommableSurface) {
        switch (type) {
            case EConsommableSurface.Bilame:
                return 'Bilame';
            case EConsommableSurface.Ecouvillon:
                return 'Ecouvillon';
            case EConsommableSurface.GeloseContact:
                return 'Gelose Contact';
            case EConsommableSurface.Lingette:
                return 'Lingette';
            default:
                return 'Not Set';
        }
    }

    static getEndoscopeTypelabel(type: EType) {
        switch (type) {
            case EType.Bronchoscope:
                return 'Bronchoscope';
            case EType.Coloscope:
                return 'Coloscope';
            case EType.Cystoscope:
                return 'Cystoscope';
            case EType.Duodenoscope:
                return 'Duodénoscope';
            case EType.Echoendoscope:
                return 'Echoendoscope';
            case EType.Gastroscope:
                return 'Gastroscope';
            case EType.Ureteroscope:
                return 'Urétéroscope';
            case EType.Scialendoscope:
                return 'Scialendoscope';
            case EType.Choledoscope:
                return 'Choledoscope';
            case EType.EchoendoBronchique:
                return 'EchoendoBronchique';
            case EType.Nasogastroscope:
                return 'Nasogastroscope';
            case EType.Enteroscope:
                return 'Entéroscope';
            case EType.Hysteroscope:
                return 'Hystéroscope'
            default:
                return 'Not Set';
        }
    }

    static getMotifPrelevementlabel(type: EMotifPrelevement) {
        switch (type) {
            case EMotifPrelevement.AppareilDePret:
                return 'Appareil de Prêt';
            case EMotifPrelevement.AppareilNeuf:
                return 'Appareil Neuf';
            case EMotifPrelevement.QPESET:
                return 'QPESET';
            case EMotifPrelevement.QPLDE:
                return 'QPLDE';
            case EMotifPrelevement.Recontrole:
                return 'Recontrole';
            case EMotifPrelevement.RetourDeReparation:
                return 'RetourDeReparation';
            case EMotifPrelevement.Routine:
                return 'Routine';
            case EMotifPrelevement.RoutineSortieESET:
                return 'Routine de sortie ESET';
            default:
                return 'Not Set';
        }
    }

    static getTraitementlabel(type: ETraitement) {
        switch (type) {
            case ETraitement.LDE:
                return 'LDE';
            case ETraitement.Manuel:
                return 'Manuel';
            case ETraitement.NonTransmis:
                return 'Non Transmis';
            case ETraitement.ProcédureClient:
                return 'Procédure Client';
            default:
                return 'Not Set';
        }
    }

    // static getCycleTraitementlabel(type: ECycleTraitement) {
    //     switch (type) {
    //         case ECycleTraitement.Complet:
    //             return 'Complet';
    //         case ECycleTraitement.Court:
    //             return 'Court';
    //         default:
    //             return 'Not Set';
    //     }
    // }

    static getTypeEauRincagelabel(type: ETypeEauRincage) {
        switch (type) {
            case ETypeEauRincage.EBM:
                return 'EBM';
            case ETypeEauRincage.EauSterile:
                return 'EauSterile';
            default:
                return 'Not Set';
        }
    }

    static getMarqueEndoscopelabel(type: EMarque) {
        switch (type) {
            case EMarque.Autre:
                return 'Autre';
            case EMarque.FujinonFujifilm:
                return 'Fujinon-Fujifilm';
            case EMarque.KarlStorz:
                return 'Karl Storz';
            case EMarque.Olympus:
                return 'Olympus';
            case EMarque.Pentax:
                return 'Pentax';
            case EMarque.Wolf:
                return 'Wolf';
            default:
                return 'Not Set';
        }
    }

    static getConditionPrelevementlabel(type: CPE) {
        switch (type) {
            case CPE.Autre:
                return 'Autre';
            case CPE.DesinfectionInf6heures:
                return 'Desinfection < 6 heures';
            case CPE.DesinfectionSup6Heures:
                return 'Desinfection > 6 Heures';
            case CPE.EnSortieDeLaveur:
                return 'En sortie de laveur';
            case CPE.EnSortieDuBainDeRincage:
                return 'En sortie du bain de rincage';
            default:
                return 'Not Set';
        }
    }

    static getConditionStockagelabel(type: EConditionStockage) {
        switch (type) {
            case EConditionStockage.AutreQueESET:
                return 'Autre';
            case EConditionStockage.Bac:
                return 'Bac';
            case EConditionStockage.ChampStérile:
                return 'Champ Stérile';
            case EConditionStockage.EauStérile:
                return 'Eau Stérile';
            case EConditionStockage.EnsachéSousAirMedical:
                return 'Ensaché Sous Air Medical';
            case EConditionStockage.SousVide:
                return 'Sous Vide';
            case EConditionStockage.StockageESET:
                return 'Stockage ESET';
            case EConditionStockage.Tiroir:
                return 'Tiroir';
            default:
                return 'Not Set';
        }
    }

    static getPorteeLabel(type: EPortee) {
        switch (type) {

            case EPortee.CanalAirEau:
                return 'Canal Air Eau';
            case EPortee.CanalAspirateur:
                return 'Canal Aspirateur';
            case EPortee.CanalAuxiliaire:
                return 'Canal Auxiliaire';
            case EPortee.CanalErecteur:
                return 'Canal Erecteur';
            case EPortee.CanalExtremiteDistale:
                return 'Canal Extrémité Distale';
            case EPortee.CanalOperateur:
                return 'Canal Opérateur';
            case EPortee.CanalWaterJet:
                return 'Canal Water Jet';
            case EPortee.Total:
                return 'Total';
            case EPortee.Touscanaux:
                return 'Tous canaux';
            default:
                return 'Not Set';
        }
    }

    static getMarqueCompteurLabel(type: EMarqueCompteur) {
        switch (type) {
            case EMarqueCompteur.ATI:
                return 'ATI';
            case EMarqueCompteur.Lighthouse:
                return 'Lighthouse';
            case EMarqueCompteur.TSI:
                return 'TSI';
            case EMarqueCompteur.PMT:
                return 'PMT';
            default:
                return 'Not Set';
        }
    }

    static getModeleCompteurLabel(type: EModeleCompteur) {
        switch (type) {
            case EModeleCompteur.Aerotrak:
                return 'AEROTRAK';
            case EModeleCompteur.ApexZ50:
                return 'Apex Z50';
            case EModeleCompteur.ATI:
                return 'ATI';
            case EModeleCompteur.ApexP3:
                return 'Apex P3';
            case EModeleCompteur.ApexZ3:
                return 'Apex Z3';
            case EModeleCompteur.LASAIR3:
                return 'LASAIR3';
            default:
                return 'Not Set';
        }
    }

    static getMarqueMultimetreLabel(type: EMarqueMultimetre) {
        switch (type) {

            case EMarqueMultimetre.KIMO:
                return 'KIMO';
            case EMarqueMultimetre.TESTO:
                return 'TESTO';
            case EMarqueMultimetre.TSI:
                return 'TSI';
            default:
                return 'Not Set';
        }
    }

    static getModeleMultimetreLabel(type: EModeleMultimetre) {
        switch (type) {
            case EModeleMultimetre.AMI300:
                return 'AMI300';
            case EModeleMultimetre.AMI310:
                return 'AMI310';
            case EModeleMultimetre.Accubalance8380:
                return 'Accubalance 8380';
            case EModeleMultimetre.M400:
                return '400';
            case EModeleMultimetre.M440:
                return '440';
            case EModeleMultimetre.Velocicalc9565:
                return 'Velocicalc 9565';
            default:
                return 'Not Set';
        }
    }

    static getSystemeTraitementAirLabel(type: ESystemeTraitementAir) {
        switch (type) {
            case ESystemeTraitementAir.FluxNonUnidirectionnel:
                return 'Flux Non Unidirectionnel';
            case ESystemeTraitementAir.FluxUnidirectionnel:
                return 'Flux Unidirectionnel';
            default:
                return 'Not Set';
        }
    }

    static getMarqueAppareilSurfaceLabel(type: EMarqueAppareilSurface) {
        switch (type) {

            case EMarqueAppareilSurface.ACSperhi:
                return 'AC-Sperhi';
            // case EMarqueAppareilAir.AES:
            //     return 'AES';
            // case EMarqueAppareilAir.OXOID:
            //     return 'OXOID';
            // case EMarqueAppareilAir.ThermoFisher:
            //     return 'ThermoFisher';
            default:
                return 'Not Set';
        }
    }

    static getModeleAppareilSurfaceLabel(type: EModeleAppareilSurface) {
        switch (type) {

            case EModeleAppareilSurface.Biocontact99:
                return 'Biocontact 99';
            case EModeleAppareilSurface.BiocontactL6:
                return 'Biocontact L6';

            default:
                return 'Not Set';
        }
    }

    static getMarqueAppareilAirLabel(type: EMarqueAppareilAir) {
        switch (type) {

            case EMarqueAppareilAir.AES:
                return 'AES';
            case EMarqueAppareilAir.Biomerieux:
                return 'Biomerieux';
            case EMarqueAppareilAir.MBV:
                return 'MBV';
            case EMarqueAppareilAir.Merck:
                return 'Merck';
            case EMarqueAppareilAir.PBI:
                return 'PBI';
            case EMarqueAppareilAir.VWR:
                return 'VWR';
            default:
                return 'Not Set';
        }
    }

    static getModeleAppareilAirLabel(type: EModeleAppareilAir) {
        switch (type) {

            case EModeleAppareilAir.AIRIDEAL3P:
                return 'AIR IDEAL 3P';
            case EModeleAppareilAir.AIRIDEAL:
                return 'AIR IDEAL';
            case EModeleAppareilAir.MAS100ECO:
                return 'MAS 100 ECO';
            case EModeleAppareilAir.MAS100NT:
                return 'MAS 100 NT';
            case EModeleAppareilAir.SAS360AirSamplerDuo:
                return 'SAS 360 AirSamplerDuo';
            case EModeleAppareilAir.SASSUPERDUO:
                return 'SAS SUPER DUO';
            case EModeleAppareilAir.SASSUPERIAQ:
                return 'SAS SUPER IAQ';
            case EModeleAppareilAir.SASDUO360:
                return 'SAS DUO 360';
            case EModeleAppareilAir.SASSuperDUO360:
                return 'SAS Super DUO 360';
            case EModeleAppareilAir.SamplAirLite:
                return 'Sampl\'air Lite';

            default:
                return 'Not Set';
        }
    }
}